import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Signuptogetstarted from "../Signuptogetstarted";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import {
  checkMobile,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import { useNavigate, useLocation } from "react-router";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { GetCountry } from "../../../../redux/master/action";
import ReactSelect from "react-select";
import { uploadImage } from "../../../../CloudStorage/uploadImage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import "react-phone-input-2/lib/style.css";
import VerifyEmailMobile from "../VerifyEmailMobile/VerifyEmailMobile";
import { scrollToTop } from "../../../../CloudStorage/CommonFunction";
import PopupPrivacyPolicy from "../../../Common/PopupPrivacyPolicy";
import { Modal } from "reactstrap";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { disabledStyle } from "../../../Common/ClickDisable";
import PhoneInputforSignUp from "./PhoneInputforSignUp";
import { handleNameKeyDown, notallowspace } from "../../../Common/FewCommonMethods";
import ProfileImageUpload from "./ProfileImageUpload"; // Import the new component
import { mobilenumbervalidation, passwordvalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { detectCountryFromIP } from "../../../../utils/detectCountryFromIP";

const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("First name is required")
    .test(
      "not-only-spaces",
      "Please enter a valid value",
      (value) => value.trim() !== ""
    ),
  last_name: Yup.string()
    .required("Last name is required")
    .test(
      "not-only-spaces",
      "Please enter a valid value",
      (value) => value.trim() !== ""
    ),
  mobile_number: mobilenumbervalidation,
  email_id: Yup.string()
    .email("Invalid email format")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email format")
    .required("Email is required"),
  password: passwordvalidation,
  conformpassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  country_code: Yup.string().required("Country code is required"),
  country_id: Yup.string().required("Country is required"),
  agree: Yup.boolean().oneOf(
    [true],
    "You must agree to the terms and conditions"
  ),
});

export default function SignUp() {
  const location = useLocation();
  const statevalues = location?.state;
  const [selectCountry, setSelectCountry] = useState("");
  const [nextpage, setNextpage] = useState(true);
  const [valuess, setValuess] = useState(null);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [selectedImage, setSelectedImage] = useState(
    statevalues?.profile_image || statevalues?.image || statevalues?.profile_image || statevalues?.image
  );

  const [modal, setModal] = useState(null);
  const dispatch = useDispatch();
  console.log(statevalues, 'statevaluesstatevaluesstatevalues');


  const [selectCountryCode, setSelectCountryCode] = useState("");

  useEffect(() => {
    detectCountryFromIP().then((res) => {
      console.log(res, 'resresresresres');

      setSelectCountryCode(res.dial_code || '+91');
    });
  }, []);

  const navigate = useNavigate();
  const path = "Assets/scss/FirstTimeUsers.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(GetCountry());
  }, [path, dispatch]);

  const initialValues = {
    first_name: valuess?.first_name || statevalues?.first_name,
    last_name: valuess?.last_name || statevalues?.last_name,
    mobile_number: valuess?.mobile_number,
    email_id: valuess?.email_id || statevalues?.email_id,
    password: valuess?.password,
    conformpassword: valuess?.conformpassword,
    country_code: valuess?.country_code || selectCountryCode || "+966",
    country_id: valuess?.country_id,
    agree: valuess?.agree || false,
    image: valuess?.image || statevalues?.profile_image || statevalues?.image || null,
  };
  console.log(initialValues, 'initialValues');

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  const handleSubmit = async (values) => {
    setLoading(true);

    let imageUrl = "";
    if (values.image && values.image instanceof File) {
      try {
        imageUrl = await uploadImage(values.image);
      } catch (error) {
        urtoast("Failed to upload image", 2);
        setLoading(false);
        return;
      }
    }
    else if (statevalues?.profile_image || statevalues?.image) {
      imageUrl = statevalues.profile_image || statevalues.image;
    }

    const data = {
      ...values,
      profile_image: imageUrl,
      reg_from: "1",
      social_id: statevalues?.social_id || "",
      social_from: statevalues?.social_from || "",
      social_token: statevalues?.social_token || "",
    };

    checkMobile(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response.message, 2);
        } else {
          sendOTP(data)
            .then((res) => {
              if (res.data.status) {
                urtoast(
                  `OTP has been sent to the Mobile number ${values.country_code} ${values.mobile_number} and Email ID ${values.email_id}`,
                  1
                );
                setNextpage(false);
                setValuess(data);
                scrollToTop();
              } else {
                urtoast(res.data.response.message, 2);
              }
            })
            .catch((e) => {
              urtoast(e.message, 2);
            });
        }
      })
      .catch((e) => {
        urtoast(e.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };


  if (!countrylist) {
    return null;
  }

  return (
    <>
      {nextpage ? (
        <div className="mx-auto register">
          <h1 className="heading">Sign up to get started</h1>
          <Signuptogetstarted />

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}  // Add this line
          >
            {({ errors, formik, values, touched, setFieldValue }) => (
              <Form autoComplete="on">
                <div className="col-md-12 form-sec">
                  {/* Use the separated ProfileImageUpload component */}
                  <ProfileImageUpload
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                    setFieldValue={setFieldValue}
                    initialImage={values?.image}
                  />
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label htmlFor="first_name">First Name <AsteriskLabel /></label>
                      <Field
                        type="text"
                        id="first_name"
                        name="first_name"
                        className="form-control"
                        placeholder="Enter first name"
                        onKeyDown={handleNameKeyDown}
                      />
                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="error"
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="last_name">Last Name <AsteriskLabel /></label>
                      <Field
                        type="text"
                        id="last_name"
                        name="last_name"
                        className="form-control"
                        placeholder="Enter last name"
                        onKeyDown={handleNameKeyDown}
                      />
                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="email_id">Email ID <AsteriskLabel /></label>
                      <Field
                        type="email"
                        id="email_id"
                        name="email_id"
                        className="form-control"
                        placeholder="Enter email ID"
                        disabled={statevalues?.email_id}
                      />
                      <ErrorMessage
                        name="email_id"
                        component="div"
                        className="error"
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <PhoneInputforSignUp
                        errors={errors}
                        formik={formik}
                        values={values}
                        touched={touched}
                        setFieldValue={setFieldValue}
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="password">Password <AsteriskLabel /></label>
                      <div className="password-btn">
                        <Field
                          onKeyDown={notallowspace}
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          className="form-control"
                          placeholder="Password (8 or more characters)"
                        />
                        <span
                          onClick={togglePasswordVisibility}
                          className="btn"
                        >
                          {showPassword ? (
                            <i className="fa-solid fa-eye" aria-hidden="true"></i>
                          ) : (
                            <i className="fa-solid fa-eye-slash"></i>
                          )}
                        </span>
                      </div>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="conformpassword">Repeat Password <AsteriskLabel /></label>
                      <div className="password-btn">

                        <Field
                          onKeyDown={notallowspace}
                          type={showPassword1 ? "text" : "password"}
                          id="conformpassword"
                          name="conformpassword"
                          className="form-control"
                          placeholder="Repeat password"
                        />
                        <span
                          onClick={togglePasswordVisibility1}
                          className="btn"
                        >
                          {showPassword1 ? (
                            <i className="fa-solid fa-eye" aria-hidden="true"></i>
                          ) : (
                            <i className="fa-solid fa-eye-slash"></i>
                          )}
                        </span>
                        <ErrorMessage
                          name="conformpassword"
                          component="div"
                          className="error"
                        />
                      </div>
                    </div>

                    <div className="col-md-12 form-group">
                      <label htmlFor="country_id"> Country <AsteriskLabel /></label>

                      <ReactSelect
                        options={
                          Array.isArray(countrylist) &&
                          countrylist.map((country) => ({
                            value: country.id,
                            label: country.title,
                          }))
                        }
                        placeholder="Select country"
                        value={selectCountry}
                        onChange={(option) => {
                          setSelectCountry(option);
                          setFieldValue("country_id", option.value);
                        }}
                      />
                      <ErrorMessage
                        name="country_id"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-10 form-group ">
                      <div className="input-check">
                        <input
                          type="checkbox"
                          onClick={() => {
                            setModal(true);
                            setFieldValue("agree", false);
                          }}
                          id="agree"
                          name="agree"
                          checked={values.agree}
                        />
                        <label htmlFor="agree">
                          Yes, I understand and agree to Urxprt's
                          <span>Terms of Service</span>, including the
                          <span> User Agreement</span> and
                          <span> Privacy Policy</span>.
                        </label>
                      </div>
                      <ErrorMessage
                        name="agree"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-12 last-form">
                      <button
                        type="submit"
                        className="btn create-account"
                        disabled={loading}
                      >
                        {loading ? (
                          <LoginLoaderButton />
                        ) : (
                          <>
                            {"Create account"}
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                              alt=""
                            />
                          </>
                        )}
                      </button>
                      <p>
                        Already have an account?{" "}
                        <a
                          style={loading ? disabledStyle : {}}
                          onClick={() => navigate(`/${lan}/loginwithemail`)}
                        >
                          {" "}
                          Login
                        </a>
                      </p>
                    </div>
                  </div>
                  {modal && (
                    <Modal
                      isOpen={modal}
                      keyboard={false}
                      className="modal-width modal-centered popupmodal termsconditionmodal"
                    >
                      <PopupPrivacyPolicy
                        setFieldValue={setFieldValue}
                        setModal={setModal}
                      />
                    </Modal>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <VerifyEmailMobile valuess={valuess} setNextpage={setNextpage} />
      )}
    </>
  );
}